<div class="content dark">
	<div class="row">
		<div class="col-12">
			<div class="item-panel flush">
				<div class="heading">Maintenance History for {{asset.asset_name}}</div>
				<div class="content">
					<div *ngIf="logs === undefined" class="text-center pt-3 pb-3">
						<div class="logo-spin light"></div>
						Loading logs...
					</div>
					<div *ngIf="logs && !logs.length">
						No maintenance logs have been entered
					</div>
					<div *ngIf="logs && logs.length" class="maintenance-list">
						<table>
							<tr>
								<th>Date</th>
								<th>Entered by</th>
								<th>LRU</th>
								<th>Summary</th>
								<th *ngIf="api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master'">
									Delete</th>
							</tr>
							<tr *ngFor="let log of logs">
								<td>{{log.ts | datetime : "offset" : asset.time_offset_hours }}</td>
								<td>{{log.author_email}}</td>
								<td>{{lookupLRU(log.lru)}}</td>
								<td class="truncate" [title]="log.user_note"><span>{{log.user_note}}</span></td>
								<td *ngIf="api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master'">
									<app-action-button [action]="DeleteMaintenance" [args]="[log.maintenance_history_id]" [context]="this" btnClass="btn-danger btn-sm" confirm="Are you sure?"
										processing="...">x</app-action-button>
								</td>
							</tr>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="row" [hidden]="this.api.user.role === 'readonly'">
		<div class="col-12">
			<div class="item-panel">
				<div class="heading">Record new maintenance event</div>
				<div class="content">
					<div class="row">
						<div class="col-lg-6">
							<ng-container *ngIf="asset.is_fixed">
								<p>Date of event:</p>
								<app-day-picker [(ngModel)]="newDate"></app-day-picker>
							</ng-container>
							<ng-container *ngIf="!asset.is_fixed">
								<label>Last operation before maintenance:</label>
								<select *ngIf="operations === undefined" class="form-control form-control-sm" disabled>
									<option>Loading operations...</option>
								</select>
								<select *ngIf="operations !== undefined" class="form-control form-control-sm op-list" [(ngModel)]="selectedOperation"
									title="Showing {{ operations && operations.length >= 800 ? 'latest 800' : 'all' }} operations with a known end time">
									<option *ngFor="let operation of operations" [ngValue]="operation"
										[ngClass]="{ 'unacked-ex' : operation.exceedance_count > 0 && !operation.exceedance_ack_by, 'acked-ex': operation.exceedance_count > 0 && operation.exceedance_ack_by, 'no-ex': operation.exceedance_count === 0 }">
										{{operation.start_time | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0)}}{{operation.rotor_turn_time |
										runtime : " Rotor: "}}{{operation.flight_time | runtime : " Flight: "}}{{operation.exceedance_count > 0 ? "
										Ex: " + operation.exceedance_count : ""}}{{operation.exceedance_count && operation.exceedance_ack_by ? "
										(ack)" : ""}}
									</option>
								</select>
							</ng-container>
							<p class="mt-4">LRU affected:</p>
							<div class="form-check" *ngFor="let lru of allLRUs">
								<label class="form-check-label">
									<input class="form-check-input" type="radio" name="lruRadios" [value]="lru" [(ngModel)]="newLRU">
									{{lru.name}}
								</label>
							</div>
						</div>
						<div class="col-lg-6">
							<div class="form-group">
								<label>Event summary:</label>
								<div>
									<textarea [(ngModel)]="newSummary" style="width: 100%;height: 150px;"></textarea>
								</div>
							</div>
							<app-action-button [action]="UploadMaintenance" [context]="this" [disabled]="!(selectedOperation || newDate) || !newSummary" processing="Saving..."
								complete="Maintenance recorded">Record
								maintenance event</app-action-button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>